import { render, staticRenderFns } from "./LandingHeader.vue?vue&type=template&id=85e88e4e&scoped=true&"
import script from "./LandingHeader.vue?vue&type=script&lang=ts&"
export * from "./LandingHeader.vue?vue&type=script&lang=ts&"
import style0 from "./LandingHeader.vue?vue&type=style&index=0&id=85e88e4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e88e4e",
  null
  
)

export default component.exports